import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  HostListener,
} from "@angular/core";
import { DsNotificationService } from "../../services/ds-notification.service";

@Component({
  selector: "ds-search-bar",
  templateUrl: "./ds-search-bar.component.html",
  styleUrls: ["./ds-search-bar.component.scss"],
})
export class DsSearchBarComponent implements AfterViewInit, OnDestroy {
  @Input() error = false;
  @Input() search?: (value: string) => void; // Deprecated: Use searchChange output instead
  @Input() clearSearch?: () => void; // Deprecated: Use clearSearchChange output instead
  @Input() searchButton = true;
  @Output() searchChange = new EventEmitter<string>();
  @Output() clearSearchChange = new EventEmitter<void>();
  private inputElement?: HTMLInputElement;
  private searchIconsElement?: HTMLElement;
  private resizeObserver?: ResizeObserver;

  constructor(private elementRef: ElementRef, private dsNotificationService: DsNotificationService) {}

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.initializeElements();
      this.setupObservers();
      if (this.inputElement && this.searchIconsElement) {
        this.centerIconsToInput();
      }
    });
  }

  ngOnDestroy(): void {
    this.cleanupObservers();
  }

  private initializeElements(): void {
    this.inputElement = this.elementRef.nativeElement.querySelector('input[type="search"]');
    this.searchIconsElement = this.elementRef.nativeElement.querySelector(".search-icons");
  }

  private setupObservers(): void {
    if (!this.inputElement) return;
    if ("ResizeObserver" in window) {
      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          this.centerIconsToInput();
        });
      });
      this.resizeObserver.observe(this.inputElement);
    }
  }

  private cleanupObservers(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = undefined;
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(): void {
    this.centerIconsToInput();
  }

  private centerIconsToInput(): void {
    if (this.inputElement && this.searchIconsElement) {
      const inputRect = this.inputElement.getBoundingClientRect();
      const containerRect = this.elementRef.nativeElement.getBoundingClientRect();

      const inputTop = inputRect.top - containerRect.top;
      const inputHeight = inputRect.height;

      const iconTop = inputTop + inputHeight / 2;

      this.searchIconsElement.style.top = `${iconTop}px`;
      this.searchIconsElement.style.transform = "translateY(-50%)";
    }
  }

  onSearch() {
    if (this.inputElement) {
      const value = this.inputElement.value;

      // Emit the new event (preferred way)
      this.searchChange.emit(value);

      // Keep backward compatibility with old Input approach
      if (this.search) {
        this.search(value);
      }
    }
  }

  onClearSearch(): void {
    if (this.inputElement && !this.inputElement.disabled) {
      this.inputElement.value = "";
      this.inputElement.dispatchEvent(new Event("input", { bubbles: true }));
      this.inputElement.focus();

      // Emit the new event (preferred way)
      this.clearSearchChange.emit();

      // Keep backward compatibility with old Input approach
      if (this.clearSearch) {
        this.clearSearch();
      }
    }
  }
}
